import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TreeViewContext } from '../context/TreeViewProvider';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
import ChevronDown from '@dtsl/icons/dist/icons/react/ChevronDown';
import ChevronRight from '@dtsl/icons/dist/icons/react/ChevronRight';
function CollapseIcon(props) {
  const {
    itemId = '',
    onChevronClickHandler = () => {},
    isNodeItem = false
  } = props;
  const {
    expanded
  } = useContext(TreeViewContext);
  const isChevronExpanded = expanded.includes(itemId);
  return /*#__PURE__*/React.createElement("span", {
    role: "button",
    "data-testid": `chevron-${itemId}`,
    "aria-label": isChevronExpanded ? 'Item Expanded' : 'Item Collapsed',
    "aria-expanded": isChevronExpanded,
    tabIndex: -1,
    className: treeStyles['sib-tree-view__item-chevron'],
    style: isNodeItem ? {
      position: 'relative',
      top: '2px'
    } : {},
    onKeyDown: null,
    onClick: e => {
      onChevronClickHandler(e);
    }
  }, isChevronExpanded ? /*#__PURE__*/React.createElement(ChevronDown, null) : /*#__PURE__*/React.createElement(ChevronRight, null));
}
CollapseIcon.propTypes = {
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChevronClickHandler: PropTypes.func,
  isNodeItem: PropTypes.bool
};
export default CollapseIcon;